// Uses temporary design
import React, { ElementType, type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup as MuiToggleButtonGroup, type ToggleButtonGroupProps } from '@mui/material';

import { LOCALES } from '@/i18n';

const ToggleButtonGroup = MuiToggleButtonGroup as ElementType<
  Omit<ToggleButtonGroupProps, 'onChange'> & {
    onChange: (event: React.MouseEvent<HTMLElement>, value: string | string[]) => void;
  }
>;

interface LanguageSwitchProps {
  onChange?: (e: React.MouseEvent<HTMLElement>) => void;
  onLocaleChange?: (locale: string) => void | Promise<void>;
}

const LanguageSwitch: FC<LanguageSwitchProps> = ({ onChange, onLocaleChange }) => {
  const { i18n, t } = useTranslation('common');

  const handleChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, value: string | string[]) => {
      const exclusiveValue = value as string;
      const locale = exclusiveValue || i18n.languages[0];
      onLocaleChange?.(locale);
      onChange?.(event);
    },
    [i18n, onChange, onLocaleChange]
  );

  return (
    <ToggleButtonGroup value={i18n.language} exclusive onChange={handleChange}>
      {LOCALES.map(locale => (
        <ToggleButton key={locale} value={locale}>
          {t(`langs.${locale}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default LanguageSwitch;
